import React from 'react';
import PropTypes from 'prop-types';

import LogoText from '../logo-text/logo-text';

import { IS_MAIN_PAGE_LOGO_HIDDEN, IS_LOGO_TEXT_SEPARATED, LogoLocation } from '../../constants';
import { getCemeteryLogoProps } from '../../utils';
import { useLocalization } from '../../contexts/localization-context';

import './cemetery-logo.scss';

const CemeteryLogo = ({ location }) => {
  const {
    logoClasses, logoSrc, logoWidth, logoHeight, 
  } = getCemeteryLogoProps(
    location,
    IS_LOGO_TEXT_SEPARATED,
  );
  
  const { getLocalization } = useLocalization();
  
  return (
    <div
      className={`cemetery-logo cemetery-logo_${location}`}
    >
      <img
        className={`${logoClasses} ${IS_MAIN_PAGE_LOGO_HIDDEN ? 'cemetery-logo__img_hidden' : ''}`}
        alt={getLocalization('Cemetery logo')}
        height={logoHeight}
        src={logoSrc}
        width={logoWidth}
      />
      {IS_LOGO_TEXT_SEPARATED && (
        <LogoText
          location={location}
          subtitle={window.APP_CEMETERY_LOGO_SUBTITLE}
          title={window.APP_CEMETERY_LOGO_TITLE}
        />
      )}
    </div>
  );
};

CemeteryLogo.propTypes = {
  location: PropTypes.oneOf(Object.values(LogoLocation)).isRequired,
};

export default CemeteryLogo;
